<template>
  <transition name="lb-fade">
    <div
      class="lb-overlay"
      @click.self="close"
      role="dialog"
      aria-modal="true"
    >
      <!-- 关闭按钮 -->
      <button class="lb-btn lb-close" @click="close" aria-label="关闭" title="关闭">
        <i class="fas fa-times"></i>
      </button>

      <!-- 上一张 -->
      <button
        v-if="images.length > 1"
        class="lb-btn lb-nav lb-nav-left"
        @click.stop="goPrev"
        aria-label="上一张"
        title="上一张"
      >
        <i class="fas fa-chevron-left"></i>
      </button>

      <!-- 大图 -->
      <img
        :key="index"
        class="lb-image"
        :src="currentSrc"
        :alt="$t('interface.product.preview_image_full', { name: productName, index: index + 1, total: images.length })"
        @click.stop
      />

      <!-- 下一张 -->
      <button
        v-if="images.length > 1"
        class="lb-btn lb-nav lb-nav-right"
        @click.stop="goNext"
        aria-label="下一张"
        title="下一张"
      >
        <i class="fas fa-chevron-right"></i>
      </button>

      <!-- 计数器 -->
      <div v-if="images.length > 1" class="lb-counter">
        {{ index + 1 }} / {{ images.length }}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ImageLightbox',
  props: {
    // 高清图片 URL 数组（已在父组件用 formatImageUrl 处理好）
    images: { type: Array, required: true },
    // 当前显示的图片索引（受控：由父组件维护，保证卡片缩略图与灯箱同步）
    index: { type: Number, default: 0 },
    productName: { type: String, default: '' }
  },
  computed: {
    currentSrc() {
      return this.images[this.index] || '';
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    goPrev() {
      const len = this.images.length;
      const target = (this.index - 1 + len) % len; // 循环到末尾
      this.$emit('navigate', target);
    },
    goNext() {
      const len = this.images.length;
      const target = (this.index + 1) % len; // 循环到开头
      this.$emit('navigate', target);
    },
    onKeydown(e) {
      if (e.key === 'Escape') this.close();
      else if (e.key === 'ArrowLeft') this.goPrev();
      else if (e.key === 'ArrowRight') this.goNext();
    }
  },
  mounted() {
    window.addEventListener('keydown', this.onKeydown);
    // 打开灯箱时锁定背景滚动
    document.body.style.overflow = 'hidden';
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onKeydown);
    document.body.style.overflow = '';
  }
};
</script>

<style scoped>
.lb-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(15, 13, 11, 0.88);
  z-index: 1100; /* 高于分享弹窗(1000) */
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.lb-image {
  max-width: 90vw;
  max-height: 85vh;
  object-fit: contain;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  animation: lb-pop 0.25s ease;
}

@keyframes lb-pop {
  from { opacity: 0; transform: scale(0.98); }
  to { opacity: 1; transform: scale(1); }
}

.lb-btn {
  position: absolute;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.12);
  color: #f6efe1;
  border: 1px solid rgba(246, 239, 225, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.25s ease, transform 0.25s ease;
  font-size: 18px;
  padding: 0;
}

.lb-btn:hover {
  background-color: rgba(179, 154, 107, 0.9);
  color: #fff;
  transform: scale(1.06);
}

.lb-close {
  top: 20px;
  right: 24px;
}

.lb-nav {
  top: 50%;
  transform: translateY(-50%);
}

.lb-nav:hover {
  transform: translateY(-50%) scale(1.06);
}

.lb-nav-left { left: 24px; }
.lb-nav-right { right: 24px; }

.lb-counter {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  color: #f6efe1;
  font-size: 14px;
  letter-spacing: 0.05em;
  background-color: rgba(0, 0, 0, 0.35);
  padding: 4px 14px;
  border-radius: 999px;
}

.lb-fade-enter-active,
.lb-fade-leave-active {
  transition: opacity 0.3s ease;
}

.lb-fade-enter,
.lb-fade-leave-to {
  opacity: 0;
}
</style>
